import {
  REQUEST_LOGISTIC_CP_ALARM,
  RESPONSE_LOGISTIC_CP_ALARM,
  REQUEST_LOGISTIC_CP_ALARM_FAILURE,
  REQUEST_LOGISTIC_CP_VARIATION,
  RESPONSE_LOGISTIC_CP_VARIATION,
  REQUEST_LOGISTIC_CP_VARIATION_FAILURE,
} from "../actions/logisticTripControlPointsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticUpdateTripControlPointAlarmDataState: queriesStates.NOT_REQUESTED,
  logisticUpdateTripControlPointVariationDataState: queriesStates.NOT_REQUESTED,
  errors: [],
};

const logisticTripControlPointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGISTIC_CP_ALARM: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointAlarmDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_CP_ALARM: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointAlarmDataState: queriesStates.READY,
      });
    }
    case REQUEST_LOGISTIC_CP_ALARM_FAILURE: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointAlarmDataState: queriesStates.FAILURE,
        errors: state.errors.concat([action.errors]),
      });
    }

    case REQUEST_LOGISTIC_CP_VARIATION: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointVariationDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_CP_VARIATION: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointVariationDataState: queriesStates.READY,
      });
    }
    case REQUEST_LOGISTIC_CP_VARIATION_FAILURE: {
      return Object.assign({}, state, {
        logisticUpdateTripControlPointVariationDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default logisticTripControlPointsReducer;
